export default "__VITE_ASSET__CgEdUKER__ 960w, __VITE_ASSET__Bi13XANw__ 1440w";